/**
 * @module prop-types
 * @desc Defines commonly used prop types, as well as prop type generators
 */
import PropTypes from 'prop-types';
/**
 * A Simple value prop
 * @typedef {number | string} SIMPLE_VALUE_PROP
 */

export var SIMPLE_VALUE_PROP = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
/**
 * An array of simple values prop
 * @typedef {SIMPLE_VALUE_PROP[]} SIMPLE_ARRAY_PROP
 * @example [1,2,3]
 * @example ['1','2']
 */

export var SIMPLE_ARRAY_PROP = PropTypes.arrayOf(SIMPLE_VALUE_PROP);
/**
 * An object of simple values prop
 * @typedef {Object.<SIMPLE_VALUE_PROP>} SIMPLE_OBJECT_PROP
 * @example {key1:1, key2:'val2'}
 */

export var SIMPLE_OBJECT_PROP = PropTypes.objectOf(SIMPLE_VALUE_PROP);
/**
 * A Renderable List
 * @typedef {Array<Object.<value:SIMPLE_VALUE_PROP, text:SIMPLE_VALUE_PROP>>} LIST_PROP
 * @example [{value:2,text:'this is 2'}]
 */

export var LIST_PROP = PropTypes.arrayOf(PropTypes.shape({
  value: SIMPLE_VALUE_PROP,
  text: SIMPLE_VALUE_PROP,
  children: PropTypes.node
}));